module.exports = [{
      plugin: require('/Users/cody/workspace/javascript/serverless/gunnertech.com/gatsby/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    }]
